import { store } from '../store'
export const mutations = {
  login (state, payload) {
    state.userState = payload
    state.loginState = false
  },
  logout (state, payload) {
    state.userState = {}
    state.loginState = true
    state.userLogged = {}
  },
  onGetFormaPago (state, payload) {
    let satFormaPago = payload.response.data.data
    payload.event.context.satFormaPago = satFormaPago
  },
  onGetMetodoPago (state, payload) {
    let satMetodoPago = payload.response.data.data
    payload.event.context.satMetodoPago = satMetodoPago
  },
  onGetMoneda (state, payload) {
    let satMoneda = payload.response.data.data
    payload.event.context.satMoneda = satMoneda
  },
  onGetPais (state, payload) {
    let satPais = payload.response.data.data
    payload.event.context.satPais = satPais
    let find = satPais.find((element) => {
      return element.c_Pais === 'MEX'
    })
    if (find !== null && payload.event.context.hasOwnProperty('items')) {
      payload.event.context.items = satPais
      payload.event.context.items.push(find)
    }
  },
  onGetCompany (state, payload) {
    let company = payload.response.data.data
    payload.event.context.company = company
  },
  onGetCompanies (state, payload) {
    let companies = payload.response.data.data
    payload.event.context.companies = companies
  },
  onReadXml (state, payload) {
    let readXml = payload.response.data.data
    payload.event.context.readXml = readXml
    let satFormaPago = payload.event.context.getSatFormaPago(readXml.Comprobante.FormaPago)
    let satMetodoPago = payload.event.context.getSatMetodoPago(readXml.Comprobante.MetodoPago)
    let currency = payload.event.context.getCurrency(readXml.Comprobante.Moneda)
    let country = payload.event.context.getCountry('MEX')
    payload.event.context.editedItem = {
      gst_receipt_types_id: 1,
      gst_categories_id: readXml.category.id,
      is_refund: false,
      comment: '',
      description: readXml.Conceptos[0].Descripcion,
      date: readXml.Comprobante.Fecha.substr(0, 10),
      currency: currency,
      exchange: readXml.Comprobante.Moneda === 'MXN' ? '1' : '',
      subtotal: readXml.Comprobante.SubTotal,
      total: readXml.Comprobante.Total,
      issuer_tax: readXml.Emisor.Rfc,
      sat_forma_pago: satFormaPago,
      sat_metodo_pago: satMetodoPago,
      folio: readXml.Comprobante.Folio,
      country: country,
      uuid: readXml.TimbreDigitalFiscal.UUID,
      validity: readXml.Estado === 'Vigente',
      validity_date: readXml.TimbreDigitalFiscal.FechaTimbrado.substr(0, 10),
      fileId: payload.event.file_id
    }
  },
  onReadXmlError (state, payload) {
    // if (payload.error.response.data.errors !== null && payload.error.response.data.errors !== undefined) {
    //   let notificationMessage = ''
    //   if (payload.error.response.data.errors.file_id) {
    //     payload.error.response.data.errors.file_id.forEach(element => {
    //       notificationMessage += element + '<br>'
    //     })
    //   }
    //   payload.event.context.loadingFile = false
    //   console.debug(notificationMessage)
    //   payload.event.context.showNotification(notificationMessage, 'error', -1)
    // }
    payload.event.context.loadingFile = false
    payload.event.context.showNotification(payload.error.response, 'error', -1)
  },
  onReadXmlToHtml (state, payload) {
    payload.event.context.cfdiDialog = true
    let cfdiHtmlOrigin = payload.response.data.data
    let cfdiHtmlDecoded = atob(cfdiHtmlOrigin)
    let cfdiHtmlUnescaped = decodeURIComponent(escape(cfdiHtmlDecoded))
    payload.event.context.cfdiHtml = cfdiHtmlUnescaped
  },
  onReadXmlToHtmlFA (state, payload) {
    payload.event.context.dialogApprobedF = true
    let cfdiHtmlOrigin = payload.response.data.data
    let cfdiHtmlDecoded = atob(cfdiHtmlOrigin)
    let cfdiHtmlUnescaped = decodeURIComponent(escape(cfdiHtmlDecoded))
    payload.event.context.cfdiHtml = cfdiHtmlUnescaped
  },
  onReadXmlToHtmlFV (state, payload) {
    payload.event.context.dialogF = true
    let cfdiHtmlOrigin = payload.response.data.data
    let cfdiHtmlDecoded = atob(cfdiHtmlOrigin)
    let cfdiHtmlUnescaped = decodeURIComponent(escape(cfdiHtmlDecoded))
    payload.event.context.cfdiHtml = cfdiHtmlUnescaped
  },
  onUserLogged (state, payload) {
    let userLogged = payload.response.data.data
    payload.event.context.userLogged = userLogged
    store.state.userLogged = userLogged
    if (payload.event.context.isAdmin !== undefined && userLogged.roles !== undefined) {
      if (userLogged.roles[0]) {
        payload.event.context.isAdmin = userLogged.roles[0].name === 'ADMIN'
      } else payload.event.context.isAdmin = false
    }
  },
  onGetPlans (state, payload) {
    let plans = payload.response.data.data
    payload.event.context.plans = plans
  },
  // Shows a error message
  onError (state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }

    if (payload.error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      payload.event.context.showNotification(payload.error.response, 'error', -1)
    }

    payload.event.context.loading = false
  },
  onGetStatus (state, payload) {
    let status = payload.response.data.data
    payload.event.context.status = status
  },
  onGetCategories (state, payload) {
    let categories = payload.response.data.data
    payload.event.context.categories = categories
  },
  onGetAreas (state, payload) {
    let areas = payload.response.data.data
    payload.event.context.areas = areas
  },
  onGetFile (state, payload) {
    let file = payload.response.data.data
    payload.event.context.dataURL = file.dataURL
    payload.event.context.dataURLFile = file.dataURL // AGREGADO PARA EL DIALOG TEMPORALMENTE
  },
  onGetBranchesCompany (state, payload) {
    let branches = payload.response.data.data.branch
    payload.event.context.branches = branches
  },
  onGetAreasCompany (state, payload) {
    let areas = payload.response.data.data
    payload.event.context.areas = areas
  },
  onGetProjectsCompany (state, payload) {
    let projects = payload.response.data.data
    payload.event.context.projects = projects
  },
  onChangeAvatar (state, payload) {
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.refreshLogged()
    payload.event.context.close()
  },
  onChangeLogo (state, payload) {
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.getCompany()
    payload.event.context.close()
  },
  onChangePass (state, payload) {
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.closePassword()
  },
  onResetPass (state, payload) {
    payload.event.context.loading = false
    payload.event.context.showNotification(payload.response, 'success', -1)
  },
  onResetPassError (state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }
    payload.event.context.showNotification(payload.error.response, 'error', -1)
    payload.event.context.loading = false
  },
  onContacts (state, payload) {
    payload.event.context.messages = payload.response.data.data
  },
  onDeleteContact (state, payload) {
    payload.event.context.get()
    payload.event.context.showNotification(payload.response, 'success', -1)
    payload.event.context.removeDialog = false
    payload.event.context.loading = false
  },
  onDownloadExpensesFiles (state, payload) {
    payload.event.context.loading = false
    payload.event.context.forceFileDownload(payload.response.data, 'ExpensesUsersFiles' + ` ${payload.event.date}-${payload.event.expensesItems.month}.zip`)
  },
  onDownloadXML (state, payload) {
    let data = payload.response.data.data.dataURL
    let type = data.slice(data.indexOf('/') + 1, data.indexOf(';'))
    let index = data.indexOf(',')
    let b64 = data.slice(index + 1)
    // convert the B64 in to a blob
    const byteCharacters = atob(b64)
    const byteNumbers = new Array(byteCharacters.length)
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i)
    }
    const byteArray = new Uint8Array(byteNumbers)
    payload.event.context.loadingXML = false
    payload.event.context.forceFileDownload(byteArray, `${payload.event.description}.${type}`)
  },
  // ESTE MÉTODO FUNCIONA COMO COMUN DE DESCARGA DE ARCHIVOS
  onDownloadFile (state, payload) {
    let data = payload.response.data.data.dataURL
    let type = data.slice(data.indexOf('/') + 1, data.indexOf(';'))
    let index = data.indexOf(',')
    let b64 = data.slice(index + 1)
    const byteCharacters = atob(b64)
    const byteNumbers = new Array(byteCharacters.length)
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i)
    }
    const byteArray = new Uint8Array(byteNumbers)
    payload.event.context.loadingDownload = false
    payload.event.context.forceFileDownload(byteArray, `${payload.event.context.$t('expenses.file') + ' ID-' + payload.event.fileId}.${type}`)
  },
  onGetZip (state, payload) {
    payload.event.context.loading = false
    // get the B64 from the response
    let data = payload.response.data.data.dataURL
    let type = data.slice(data.indexOf('/') + 1, data.indexOf(';'))
    let index = data.indexOf(',')
    let b64 = data.slice(index + 1)
    // convert the B64 in to a blob
    const byteCharacters = atob(b64)
    const byteNumbers = new Array(byteCharacters.length)
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i)
    }
    const byteArray = new Uint8Array(byteNumbers)
    payload.event.context.loadFile = false
    payload.event.context.loadBtn = false
    payload.event.context.forceFileDownload(byteArray, `Attach_File_${payload.event.fileId}.${type}`)
  },
  setPaginated (state, payload) {
    state.paginated = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js